import { useDispatch } from 'react-redux'
import { useIntl, defineMessages } from 'react-intl'
import { Icon, Button } from '@homebotapp/hb-react-component-catalog'
import { setBombBombOpen } from '../../../store/slices/bombBomb'
import { GLOBAL_AGENT_NAVIGATION } from '../../../constants/tracking/trackingEventLocations/globalTrackingEventLocation'

export const MSG = defineMessages({
  record: {
    id: 'BombBomb.control.recordButton',
    defaultMessage: 'Record a BombBomb'
  }
})

export const BombBombButton = () => {
  const intl = useIntl()
  const dispatch = useDispatch()

  return (
    <Button
      size='sm'
      marginBottom={0}
      color='danger.500'
      leftIcon={<Icon name='record-video' />}
      onClick={() => dispatch(setBombBombOpen(true))}
      tracking={{
        guid: 'qg6GnaXrL3vW1iH4ijM6xy',
        ui_context: GLOBAL_AGENT_NAVIGATION,
        descriptor: MSG.record.defaultMessage
      }}
    >
      {intl.formatMessage(MSG.record)}
    </Button>
  )
}
